import { 
    getDataWithParams,
    downloadFile,
    postData,
    destroyData
} from "@/store/api/method-mbkm";

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "ASC",
    search: null
}

const itemInit = {
    id: null,
    detail_id: null,
    logdate: null,
    logvalue: null,
    tempDate: null
}

const initialState = () => ({
    data: {},
    msg: "Jaringan bermasalah",
    status: 0,
    blobData: null,
    request: {...requestInit},
    item: {...itemInit}
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getItem: state => state.item,
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getBlobData: state => state.blobData
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

const actions = {
    setRequest({commit }, value) {
        commit('SET_REQUEST', value)
    },
    resetRequest({commit }) {
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit }, value) {
        commit('SET_ITEM', value)
    },
    resetItem({commit }) {
        commit('SET_ITEM', {...requestInit})
    },
    async getDataLogbook ({commit, state }, id) {
        try {
            const url = `/humanityproject-logbook/${id}`
            const response = await getDataWithParams(url, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async post ({commit }, {data, id}) {
        try {
            const url = `/humanityproject-logbook/${id}`
            const response = await postData(url, data)
            commit ('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async update ({commit }, {data, id}) {
        try {
            const url = `/humanityproject-logbook/update/${id}`
            const response = await postData(url, data)
            commit ('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async delete ({commit }, id) {
        try {
            const url = `/humanityproject-logbook/${id}`
            const response = await destroyData(url)
            commit ('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async downloadProposal({commit }, {id, type}) {
        try {
            const url =  `/humanityproject-logbook/download/${id}`
            var response = await downloadFile(url)
            commit ('SET_BLOBDATA', {value: response.data, type: type})
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}